import { React, useEffect, useState, useRef } from 'react';

import { Box, Button, IconButton, Typography, useTheme } from "@mui/material";
import { tokens, useHideMode } from "../../theme";
import CurrencyFormat from 'react-currency-format';
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import Header from "../../components/Header";
import NetWorthChart from "../../components/NetWorthChart";
// import GeographyChart from "../../components/GeographyChart";
import BarChart from "../../components/BarChart";
import StatBox from "../../components/StatBox";
import ProgressCircle from "../../components/ProgressCircle";
import useAuth from "../../hooks/useAuth";
import axios from '../../api/axios'
import useAxiosPrivate from "../../hooks/useAxiosPrivate"
import { useLocation, useNavigate } from 'react-router-dom';
import RecentTransactions from '../../components/RecentTransactions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import handleError from '../../hooks/handleError';
import TwoFactorAuthPopup from '../../components/TwoFactorAuthPopup';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BucketBox from '../../components/BucketBox';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SellIcon from '@mui/icons-material/Sell';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import CelebrationIcon from '@mui/icons-material/Celebration';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import HouseIcon from '@mui/icons-material/House';
import CurrencyBitcoinIcon from '@mui/icons-material/CurrencyBitcoin';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import saveTransactions from '../../components/managers/saveTransactions';




const Dashboard = () => {
    useEffect(() => {
        document.title = 'Dashboard | Fretless Finance';
    }, []);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const hideTheme = useHideMode();
    const { setAuth } = useAuth();
    const axiosPrivate = useAxiosPrivate();
    var [recentTransactions, setRecentTrans] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const effectRan = useRef(false);
    var isMounted = false;
    var NWisMounted = false;
    const controller = new AbortController();
    var [data, setNetWorthData] = useState([]);
    const [currentNetWorth, setCurrentNetWorth] = useState(null);
    const [buckets, setBuckets] = useState([]);
    const NWeffectRan = useRef(false);
    const netWorthController = new AbortController();
    const [openTwoFactorAuth, setOpenTwoAuth] = useState(false);
    const [twoFATitle, set2FATitle] = useState();
    const [twoFA_answer_url, set2FAAnswerURL] = useState();
    const [loading, setLoading] = useState(false);
    const getBucketsEffectRan = useRef(false);


    const [businessRevenueBucket, setBusinessRevenueBucket] = useState({});
    const [businessExpensesBucket, setBusinessExpensesBucket] = useState({});
    const [livingExpensesBucket, setLivingExpensesBucket] = useState({});
    const [miscBucket, setMiscBucket] = useState({});
    const [foodBucket, setFoodBucket] = useState({});
    const [solo401kAvailEmployerContribs, setSolo401kAvailEmployerContribs] = useState({});
    const [brokerageAvailFunds, setBrokerageAvailFunds] = useState({});
    const [cryptoAvailFunds, setCryptoAvailFunds] = useState({});





    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 2,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    dots: true,
                    infinite: true,
                    speed: 500,
                    slidesToShow: 3,
                    slidesToScroll: 3
                },
            },
            {
                breakpoint: 600,
                settings: {
                    dots: true,
                    infinite: true,
                    speed: 500,
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 500,
                settings: {
                    dots: true,
                    infinite: true,
                    speed: 500,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
        ]
    };





    // Get Recent Transactions
    useEffect(() => {
        if (effectRan.current === false) {
            let isMounted = true;
            const controller = new AbortController();
            const getRecentTransactions = async () => {
                try {
                    var recentTransResponse = await axiosPrivate.get('/transactions?reverse_sort=true&unconfirmed=true', {
                        signal: controller.signal
                    });
                    isMounted && setRecentTrans(recentTransResponse.data)
                } catch (err) {
                    if (!err?.response) {
                        toast.error('No Server Response For Transactions', {
                            position: "bottom-left",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                    } else if ((err.response?.status === 401) || (err.response?.status === 403)) {
                        navigate('/sign-in', { state: { from: location }, replace: true });
                    } else if (err.response?.status === 400) {
                        toast.error(err.response?.data?.detail, {
                            position: "bottom-left",
                            autoClose: false,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                    } else {
                        toast.error(`Error ${err.response?.status} Occurred: ${err.response?.detail}`,
                            {
                                position: "bottom-left",
                                autoClose: false,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "colored",
                            });
                    }
                }
            }

            getRecentTransactions();
            effectRan.current = true;
        }

        return () => {
            isMounted = false;
            controller.abort();

        }

    }, [])

    // Handle button for confirming transactions
    const handleConfirmClick = (event, cellValues) => {
        cellValues.row["actions"] = "UPDATE";
        cellValues.row["needs_reviewed"] = false;
        saveTransactions([cellValues.row])
        setRecentTrans(recentTransactions.filter((transaction) => transaction.id !== cellValues.row["id"]));
    }







    // Get Net Worth Data
    useEffect(() => {
        if (NWeffectRan.current === false) {
            let NWisMounted = true;
            const netWorthController = new AbortController();
            const getNetWorthData = async () => {
                try {
                    var netWorthDataResponse = await axiosPrivate.get('/net-worth', {
                        signal: netWorthController.signal
                    });

                    NWisMounted && setNetWorthData(netWorthDataResponse.data)
                    NWisMounted && setCurrentNetWorth(netWorthDataResponse.data[netWorthDataResponse.data.length - 1]?.y)

                } catch (err) {
                    if (!err?.response) {
                        console.log(err)
                        toast.error('No Server Response For Net Worth', {
                            position: "bottom-left",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                    } else if ((err.response?.status === 401) || (err.response?.status === 403)) {
                        navigate('/sign-in', { state: { from: location }, replace: true });
                    } else if (err.response?.status === 400) {
                        toast.error(err.response?.data?.detail, {
                            position: "bottom-left",
                            autoClose: false,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                    } else {
                        toast.error(`Error ${err.response?.status} Occurred: ${err.response?.detail}`,
                            {
                                position: "bottom-left",
                                autoClose: false,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "colored",
                            });
                    }
                }
            }

            getNetWorthData();
            NWeffectRan.current = true;
        }
        return () => {
            NWisMounted = false;
            netWorthController.abort();

        }

    }, [])

    // Get Buckets
    useEffect(() => {
        if (getBucketsEffectRan.current === false) {

            // isMounted.current = true;
            const controller = new AbortController();

            const getBuckets = async () => {
                try {
                    var BucketsResponse = await axiosPrivate.get('/buckets', {
                        signal: controller.signal
                    });
                    // isMounted && setBuckets(BucketsResponse.data);
                    BucketsResponse && setBuckets(BucketsResponse.data)

                } catch (err) {
                    if ((err.response?.status === 401) || (err.response?.status === 403)) {
                        navigate('/sign-in', { state: { from: location }, replace: true });
                    }
                    else {
                        handleError(err);
                    }
                }
            }

            getBuckets();
            getBucketsEffectRan.current = true;
        }
        return () => {
            // isMounted.current = false;
            controller.abort();

        }

    }, [])

    useEffect(() => {
        if (buckets.length > 0) {
            setBusinessRevenueBucket(buckets.find(bucket => bucket?.name === "Business Revenue" && bucket?.bucket_type === "primary") || {});
            setBusinessExpensesBucket(buckets.find(bucket => bucket?.name === "Business Expenses" && bucket?.bucket_type === "primary") || {});
            setLivingExpensesBucket(buckets.find(bucket => bucket?.name === "Living Expenses" && bucket?.bucket_type === "primary") || {});
            setMiscBucket(buckets.find(bucket => bucket?.name === "Misc" && bucket?.bucket_type === "primary") || {});
            setFoodBucket(buckets.find(bucket => bucket?.name === "Food" && bucket?.bucket_type === "sub") || {});
            setSolo401kAvailEmployerContribs(buckets.find(bucket => bucket?.name === "Solo 401(k) Avail Employer Contributions" && bucket?.bucket_type === "sub") || {});
            setBrokerageAvailFunds(buckets.find(bucket => bucket?.name === "Brokerage Avail Funds" && bucket?.bucket_type === "sub") || {});
            setCryptoAvailFunds(buckets.find(bucket => bucket?.name === "Crypto Avail Funds" && bucket?.bucket_type === "sub") || {});

        }
    }, [buckets]);


    const fetchNetWorth = async () => {
        var fetchSucess = false;

        const getNetWorthData = async () => {
            try {
                var netWorthDataResponse = await axiosPrivate.get('/net-worth', {
                    signal: netWorthController.signal
                });

                setNetWorthData(netWorthDataResponse.data)
                setCurrentNetWorth(netWorthDataResponse.data[netWorthDataResponse.data.length - 1]?.y)

            } catch (err) {
                if (!err?.response) {
                    console.log(err)
                    toast.error('No Server Response For Net Worth', {
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                } else if ((err.response?.status === 401) || (err.response?.status === 403)) {
                    navigate('/sign-in', { state: { from: location }, replace: true });
                } else if (err.response?.status === 400) {
                    toast.error(err.response?.data?.detail, {
                        position: "bottom-left",
                        autoClose: false,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                } else {
                    toast.error(`Error ${err.response?.status} Occurred`,
                        {
                            position: "bottom-left",
                            autoClose: false,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                }
            }
        };

        try {
            setLoading(true);
            const fetchNetWorthResponse = await axiosPrivate.post(`/net-worth/fetch`, {
                signal: controller.signal
            });


            if (isMounted.current) {
                fetchSucess = true;

            }
        } catch (err) {
            if ((err.response?.status === 401) || (err.response?.status === 403)) {
                navigate('/sign-in', { state: { from: location }, replace: true });
            }
            else if ((err.response?.status === 400) & (err.response?.data?.detail === "Personal Capital login requires Two Factor Authentication")) {
                // handle pop up for 2FA
                set2FAAnswerURL("/connected-accounts/personal-capital/2fa-answer");
                set2FATitle("Empower");
                setOpenTwoAuth(true);
            }

            else {
                handleError(err);
            }
        }
        setNetWorthData([]);

        getNetWorthData();

        setLoading(false);
    }


    const fetchData = async () => {
        var fetchSucess = false;
        const getRecentTransactions = async () => {
            try {
                var recentTransResponse = await axiosPrivate.get('/transactions?reverse_sort=true&unconfirmed=true', {
                    signal: controller.signal
                });
                setRecentTrans(recentTransResponse.data)
            } catch (err) {
                if (!err?.response) {
                    toast.error('No Server Response For Transactions', {
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                } else if ((err.response?.status === 401) || (err.response?.status === 403)) {
                    navigate('/sign-in', { state: { from: location }, replace: true });
                } else if (err.response?.status === 400) {
                    toast.error(err.response?.data?.detail, {
                        position: "bottom-left",
                        autoClose: false,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                } else {
                    toast.error(`Error ${err.response?.status} Occurred`,
                        {
                            position: "bottom-left",
                            autoClose: false,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                }
            }
        }
        const getNetWorthData = async () => {
            try {
                var netWorthDataResponse = await axiosPrivate.get('/net-worth', {
                    signal: netWorthController.signal
                });

                setNetWorthData(netWorthDataResponse.data)
                setCurrentNetWorth(netWorthDataResponse.data[netWorthDataResponse.data.length - 1]?.y)

            } catch (err) {
                if (!err?.response) {
                    console.log(err)
                    toast.error('No Server Response For Net Worth', {
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                } else if ((err.response?.status === 401) || (err.response?.status === 403)) {
                    navigate('/sign-in', { state: { from: location }, replace: true });
                } else if (err.response?.status === 400) {
                    toast.error(err.response?.data?.detail, {
                        position: "bottom-left",
                        autoClose: false,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                } else {
                    toast.error(`Error ${err.response?.status} Occurred`,
                        {
                            position: "bottom-left",
                            autoClose: false,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                }
            }
        };
        const getBuckets = async () => {
            try {
                var BucketsResponse = await axiosPrivate.get('/buckets', {
                    signal: controller.signal
                });
                // isMounted && setBuckets(BucketsResponse.data);
                setBuckets(BucketsResponse.data)



            } catch (err) {
                if ((err.response?.status === 401) || (err.response?.status === 403)) {
                    navigate('/sign-in', { state: { from: location }, replace: true });
                }
                else {
                    handleError(err);
                }
            }

        }
        try {
            setLoading(true);
            const fetchTransactionsResponse = await axiosPrivate.post(`/transactions/fetch`, {
                signal: controller.signal
            });
            const fetchNetWorthResponse = await axiosPrivate.post(`/net-worth/fetch`, {
                signal: controller.signal
            });


            if (isMounted.current) {
                fetchSucess = true;

            }
        } catch (err) {
            if ((err.response?.status === 401) || (err.response?.status === 403)) {
                navigate('/sign-in', { state: { from: location }, replace: true });
            }
            else if ((err.response?.status === 400) & (err.response?.data?.detail === "Personal Capital login requires Two Factor Authentication")) {
                // handle pop up for 2FA
                set2FAAnswerURL("/connected-accounts/personal-capital/2fa-answer");
                set2FATitle("Empower");
                setOpenTwoAuth(true);
            }

            else {
                handleError(err);
            }
        }
        setRecentTrans([]);
        setNetWorthData([]);

        getRecentTransactions();
        getNetWorthData();
        getBuckets();

        setLoading(false);
    }

    const downloadData = async () => {
        try {
            var downloadDataResponse = await axiosPrivate.get('/stats/download-data', {
                signal: controller.signal,
                responseType: 'blob'
            });

            var blob = new Blob([downloadDataResponse.data], { type: 'application/zip' });

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);

            const currentDate = new Date().toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' }).replace(/\//g, '');
            link.download = `${currentDate}_FretlessFinance_export.zip`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (err) {
            if ((err.response?.status === 401) || (err.response?.status === 403)) {
                navigate('/sign-in', { state: { from: location }, replace: true });
            }
            else {
                handleError(err);
            }
        }

    }

    const handleUpdateDataClick = event => {
        fetchData();
    }

    const handleUpdateNetWorthClick = event => {
        fetchNetWorth();
    }

    const handleDownloadDataClick = event => {
        downloadData();
    }


    return (

        <Box m="20px">
            <TwoFactorAuthPopup
                answerURL={twoFA_answer_url?.toString()}
                connected_account={twoFATitle}
                openTwoAuth={openTwoFactorAuth}
                setOpenTwoAuth={setOpenTwoAuth}>
            </TwoFactorAuthPopup>
            <ToastContainer />



            {/* HEADER */}
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Header
                    title="DASHBOARD"
                    titleSize="h2"
                    subtitle="Everything in one place"
                    subtitleSize="h5"
                />


                <Box>

                    {(loading) ?
                        <RotateRightIcon
                            className="rotate-icon"

                            style={{ marginRight: "0%" }}
                        />
                        :
                        ""
                    }

                    <Button
                        onClick={() => { handleUpdateDataClick() }}
                        sx={{
                            marginRight: "0%",
                            backgroundColor: colors.blueAccent[400],
                            color: "#ffffff",
                            '&:hover': {
                                backgroundColor: colors.blueAccent[100],
                                color: "#ffffff",
                            },
                            fontSize: "14px",
                            fontWeight: "bold",
                            padding: "10px 20px",
                        }}
                    >
                        <SyncAltIcon sx={{ mr: "10px" }} />
                        Update Data
                    </Button>

                    <Button
                        onClick={() => { handleDownloadDataClick() }}
                        sx={{
                            marginRight: "0%",
                            // backgroundColor: colors.blueAccent[400],
                            color: "#7d7d7d",
                            // '&:hover': {
                            //     backgroundColor: colors.blueAccent[100],
                            //     color: "#ffffff",
                            // },
                            // fontSize: "14px",
                            // fontWeight: "bold",
                            padding: "10px 20px",
                        }}
                    >
                        <DownloadOutlinedIcon sx={{ mr: "10px" }} />
                    </Button>
                </Box>
            </Box>

            {/* GRID & CHARTS */}

            <Box
                display="grid"
                gridTemplateColumns="repeat(12, 1fr)"
                gridAutoRows="35px"
                gap="20px"
            >
                {/* {/* CONDITIONAL RECENT TRANSACTIONS */}
                {(recentTransactions.length > 0) ? (
                    <Box
                        gridColumn="span 12"
                        gridRow="span 9"

                        backgroundColor={colors.primary[400]}
                        overflow="auto">

                        <Header
                            title="Recent Transactions"
                            titleSize="h3"
                            subtitle="Confirm These Transactions"
                            subtitleSize="h5"
                        />

                        {RecentTransactions(recentTransactions, handleConfirmClick)}
                    </Box>
                ) : ""}


                {/* ROW 2 */}

                <Box gridColumn="span 12" gridRow="span 4">
                    <Slider className='slider' {...sliderSettings} height="80vh">
                        <div>
                            <Box
                                backgroundColor={colors.primary[400]}
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                sx={{ padding: "20px", marginRight: "2.5%", marginLeft: "2.5%", marginBottom: "25px" }}
                            >
                                <BucketBox
                                    amount={<CurrencyFormat
                                        thousandSeparator=","
                                        prefix="$"
                                        decimalScale={2}
                                        value={businessRevenueBucket?.amount ? (businessRevenueBucket?.amount / 100000000) : "-"}
                                        displayType="text"
                                        style={{ color: businessRevenueBucket?.amount > 0 ? colors.greenAccent[400] : colors.redAccent[400] }}
                                    />
                                    }
                                    cap={<CurrencyFormat
                                        thousandSeparator=","
                                        prefix="$"
                                        decimalScale={2}
                                        value={businessRevenueBucket?.cap ? (businessRevenueBucket?.cap / 100000000) : "-"}
                                        displayType="text"
                                        style={{ color: colors.blueAccent[700] }}
                                    />
                                    }
                                    title={businessRevenueBucket?.name}
                                    progress={businessRevenueBucket?.amount / (businessRevenueBucket?.cap + 1)}
                                    icon={
                                        <AttachMoneyIcon
                                            sx={{ color: colors.blueAccent[300], fontSize: "26px" }}
                                        />
                                    }
                                />
                            </Box>
                        </div>
                        <div>
                            <Box
                                backgroundColor={colors.primary[400]}
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                sx={{ padding: "20px", marginRight: "2.5%", marginLeft: "2.5%", marginBottom: "25px" }}
                            >
                                <BucketBox
                                    amount={<CurrencyFormat
                                        thousandSeparator=","
                                        prefix="$"
                                        decimalScale={2}
                                        value={businessExpensesBucket?.amount ? (businessExpensesBucket?.amount / 100000000) : "-"}
                                        displayType="text"
                                        style={{ color: businessExpensesBucket?.amount > 0 ? colors.greenAccent[400] : colors.redAccent[400] }}
                                    />
                                    }
                                    cap={<CurrencyFormat
                                        thousandSeparator=","
                                        prefix="$"
                                        decimalScale={2}
                                        value={businessExpensesBucket?.cap ? (businessExpensesBucket?.cap / 100000000) : "-"}
                                        displayType="text"
                                        style={{ color: colors.blueAccent[700] }}
                                    />
                                    }
                                    title={businessExpensesBucket?.name}
                                    progress={businessExpensesBucket?.amount / (businessExpensesBucket?.cap + 1)}
                                    icon={
                                        <SellIcon
                                            sx={{ color: colors.blueAccent[300], fontSize: "26px" }}
                                        />
                                    }
                                />
                            </Box>
                        </div>
                        <div>
                            <Box
                                backgroundColor={colors.primary[400]}
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                sx={{ padding: "20px", marginRight: "2.5%", marginLeft: "2.5%", marginBottom: "25px" }}
                            >
                                <BucketBox
                                    amount={<CurrencyFormat
                                        thousandSeparator=","
                                        prefix="$"
                                        decimalScale={2}
                                        value={livingExpensesBucket?.amount ? (livingExpensesBucket?.amount / 100000000) : "-"}
                                        displayType="text"
                                        style={{ color: livingExpensesBucket?.amount > 0 ? colors.greenAccent[400] : colors.redAccent[400] }}
                                    />
                                    }
                                    cap={<CurrencyFormat
                                        thousandSeparator=","
                                        prefix="$"
                                        decimalScale={2}
                                        value={livingExpensesBucket?.cap ? (livingExpensesBucket?.cap / 100000000) : "-"}
                                        displayType="text"
                                        style={{ color: colors.blueAccent[700] }}
                                    />
                                    }
                                    title={livingExpensesBucket?.name}
                                    progress={livingExpensesBucket?.amount / (livingExpensesBucket?.cap + 1)}
                                    icon={
                                        <HouseIcon
                                            sx={{ color: colors.blueAccent[300], fontSize: "26px" }}
                                        />
                                    }
                                />
                            </Box>
                        </div>
                        <div>
                            <Box
                                backgroundColor={colors.primary[400]}
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                sx={{ padding: "20px", marginRight: "2.5%", marginLeft: "2.5%", marginBottom: "25px" }}
                            >
                                <BucketBox
                                    amount={<CurrencyFormat
                                        thousandSeparator=","
                                        prefix="$"
                                        decimalScale={2}
                                        value={miscBucket?.amount ? (miscBucket?.amount / 100000000) : "-"}
                                        displayType="text"
                                        style={{ color: miscBucket?.amount > 0 ? colors.greenAccent[400] : colors.redAccent[400] }}
                                    />
                                    }
                                    cap={<CurrencyFormat
                                        thousandSeparator=","
                                        prefix="$"
                                        decimalScale={2}
                                        value={miscBucket?.cap ? (miscBucket?.cap / 100000000) : "-"}
                                        displayType="text"
                                        style={{ color: colors.blueAccent[700] }}
                                    />
                                    }
                                    title={miscBucket?.name}
                                    progress={miscBucket?.amount / (miscBucket?.cap + 1)}
                                    icon={
                                        <CelebrationIcon
                                            sx={{ color: colors.blueAccent[300], fontSize: "26px" }}
                                        />
                                    }
                                />
                            </Box>
                        </div>
                        <div>
                            <Box
                                backgroundColor={colors.primary[400]}
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                sx={{ padding: "20px", marginRight: "2.5%", marginLeft: "2.5%", marginBottom: "25px" }}
                            >
                                <BucketBox
                                    amount={<CurrencyFormat
                                        thousandSeparator=","
                                        prefix="$"
                                        decimalScale={2}
                                        value={foodBucket?.amount ? (foodBucket?.amount / 100000000) : "-"}
                                        displayType="text"
                                        style={{ color: foodBucket?.amount > 0 ? colors.greenAccent[400] : colors.redAccent[400] }}
                                    />
                                    }
                                    cap={<CurrencyFormat
                                        thousandSeparator=","
                                        prefix="$"
                                        decimalScale={2}
                                        value={foodBucket?.cap ? (foodBucket?.cap / 100000000) : "-"}
                                        displayType="text"
                                        style={{ color: colors.blueAccent[700] }}
                                    />
                                    }
                                    title={foodBucket?.name}
                                    progress={foodBucket?.amount / (foodBucket?.cap + 1)}
                                    icon={
                                        <RestaurantIcon
                                            sx={{ color: colors.blueAccent[300], fontSize: "26px" }}
                                        />
                                    }
                                />
                            </Box>
                        </div>
                        <div>
                            <Box
                                backgroundColor={colors.primary[400]}
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                sx={{ padding: "20px", marginRight: "2.5%", marginLeft: "2.5%", marginBottom: "25px" }}
                            >
                                <BucketBox
                                    amount={<CurrencyFormat
                                        thousandSeparator=","
                                        prefix="$"
                                        decimalScale={2}
                                        value={solo401kAvailEmployerContribs?.amount ? (solo401kAvailEmployerContribs?.amount / 100000000) : "-"}
                                        displayType="text"
                                        style={{ color: solo401kAvailEmployerContribs?.amount > 0 ? colors.greenAccent[400] : colors.redAccent[400] }}
                                    />
                                    }
                                    cap={<CurrencyFormat
                                        thousandSeparator=","
                                        prefix="$"
                                        decimalScale={2}
                                        value={solo401kAvailEmployerContribs?.cap ? (solo401kAvailEmployerContribs?.cap / 100000000) : "-"}
                                        displayType="text"
                                        style={{ color: colors.blueAccent[700] }}
                                    />
                                    }
                                    title="i401k Avail Employer Contributions"
                                    progress={solo401kAvailEmployerContribs?.amount / (solo401kAvailEmployerContribs?.cap + 1)}
                                    icon={
                                        <AccountBalanceIcon
                                            sx={{ color: colors.blueAccent[300], fontSize: "26px" }}
                                        />
                                    }
                                />
                            </Box>
                        </div>
                        <div>
                            <Box
                                backgroundColor={colors.primary[400]}
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                sx={{ padding: "20px", marginRight: "2.5%", marginLeft: "2.5%", marginBottom: "25px" }}
                            >
                                <BucketBox
                                    amount={<CurrencyFormat
                                        thousandSeparator=","
                                        prefix="$"
                                        decimalScale={2}
                                        value={brokerageAvailFunds?.amount ? (brokerageAvailFunds?.amount / 100000000) : "-"}
                                        displayType="text"
                                        style={{ color: brokerageAvailFunds?.amount > 0 ? colors.greenAccent[400] : colors.redAccent[400] }}
                                    />
                                    }
                                    cap={<CurrencyFormat
                                        thousandSeparator=","
                                        prefix="$"
                                        decimalScale={2}
                                        value={brokerageAvailFunds?.cap ? (brokerageAvailFunds?.cap / 100000000) : "-"}
                                        displayType="text"
                                        style={{ color: colors.blueAccent[700] }}
                                    />
                                    }
                                    title={brokerageAvailFunds?.name}
                                    progress={brokerageAvailFunds?.amount / (brokerageAvailFunds?.cap + 1)}
                                    icon={
                                        <TrendingUpIcon
                                            sx={{ color: colors.blueAccent[300], fontSize: "26px" }}
                                        />
                                    }
                                />
                            </Box>
                        </div>
                        <div>
                            <Box
                                backgroundColor={colors.primary[400]}
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                sx={{ padding: "20px", marginRight: "2.5%", marginLeft: "2.5%", marginBottom: "25px" }}
                            >
                                <BucketBox
                                    amount={<CurrencyFormat
                                        thousandSeparator=","
                                        prefix="$"
                                        decimalScale={2}
                                        value={cryptoAvailFunds?.amount ? (cryptoAvailFunds?.amount / 100000000) : "-"}
                                        displayType="text"
                                        style={{ color: cryptoAvailFunds?.amount > 0 ? colors.greenAccent[400] : colors.redAccent[400] }}
                                    />
                                    }
                                    cap={<CurrencyFormat
                                        thousandSeparator=","
                                        prefix="$"
                                        decimalScale={2}
                                        value={cryptoAvailFunds?.cap ? (cryptoAvailFunds?.cap / 100000000) : "-"}
                                        displayType="text"
                                        style={{ color: colors.blueAccent[700] }}
                                    />
                                    }
                                    title={cryptoAvailFunds?.name}
                                    progress={cryptoAvailFunds?.amount / (cryptoAvailFunds?.cap + 1)}
                                    icon={
                                        <CurrencyBitcoinIcon
                                            sx={{ color: colors.blueAccent[300], fontSize: "26px" }}
                                        />
                                    }
                                />
                            </Box>
                        </div>

                    </Slider>
                </Box>

                {/* ROW 3 */}

                <Box
                    gridColumn="span 6"
                    gridRow="span 9"
                    backgroundColor={colors.primary[400]}
                >
                    <Box
                        mt="25px"
                        p="0 30px"
                        display="flex "
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Box>
                            <Typography
                                variant="h5"
                                fontWeight="600"
                                color={colors.grey[100]}
                            >
                                Net Worth
                            </Typography>
                            <Typography
                                variant="h2"
                                fontWeight="bold"
                                color={colors.greenAccent[500]}
                            >
                                {hideTheme.mode === "show" ? (currentNetWorth ? <CurrencyFormat
                                    thousandSeparator=","
                                    prefix="$"
                                    decimalScale={2}
                                    value={currentNetWorth}
                                    displayType="text"

                                /> : null) : "*********"}
                            </Typography>
                        </Box>
                        <Box>
                            <IconButton>
                                <DownloadOutlinedIcon
                                    sx={{ fontSize: "26px", color: colors.blueAccent[500] }}
                                />
                            </IconButton>
                        </Box>
                    </Box>
                    <Box height="375px" m="-20px 0 0 0">
                        <NetWorthChart isDashboard={true} data={data} />
                    </Box>
                </Box>
                <Box
                    gridColumn="span 2"
                    gridRow="span 2"
                >
                    <Button
                        onClick={() => { handleUpdateNetWorthClick() }}
                        sx={{
                            height: "50px",
                            width: "175px",
                            marginRight: "0%",
                            backgroundColor: colors.blueAccent[400],
                            color: "#ffffff",
                            '&:hover': {
                                backgroundColor: colors.blueAccent[100],
                                color: "#ffffff",
                            },
                            fontSize: "14px",
                            fontWeight: "bold",
                            padding: "10px 20px",
                        }}
                    >
                        <SyncAltIcon sx={{ mr: "10px" }} />
                        Update Net Worth
                    </Button>
                </Box>


            </Box>

        </Box >

    );
};

export default Dashboard;